import { render } from "./SettingsMain.vue?vue&type=template&id=f41382c2&scoped=true"
import script from "./SettingsMain.vue?vue&type=script&lang=js"
export * from "./SettingsMain.vue?vue&type=script&lang=js"

import "./SettingsMain.vue?vue&type=style&index=0&id=f41382c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41382c2"]])

export default __exports__